import { useMemo } from 'react';
import 'baseui/accordion';
import 'react/jsx-runtime';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { mergeOverrides } from '../../overrides.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getAccordionOverrideStyle = (element, { kind }) => ({ $theme }) => {
  switch (element) {
    case "Root":
      return __spreadValues(__spreadValues({
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "transparent",
        backgroundColor: $theme.colors["background-global-primary"],
        paddingRight: $theme.space[16],
        paddingLeft: $theme.space[16],
        borderRadius: $theme.radii[4],
        overflow: "hidden",
        ":empty": {
          display: "none"
        }
      }, kind === "secondary" && {
        backgroundColor: $theme.colors["background-global-secondary"]
      }), kind === "outlined" && {
        borderColor: $theme.colors["borders-global-tertiary"]
      });
    default:
      return {};
  }
};
const useAccordionOverrides = (overrides, $style, props) => {
  const resolvedStyles = useResolvedStyle($style);
  return useMemo(() => mergeOverrides({
    Root: {
      style: (styleProps) => mergeStyles(getAccordionOverrideStyle("Root", props)(styleProps), resolvedStyles)
    },
    Content: {
      style: getAccordionOverrideStyle("Content", props)
    },
    ContentAnimationContainer: {
      style: getAccordionOverrideStyle("ContentAnimationContainer", props)
    },
    Header: {
      style: getAccordionOverrideStyle("Header", props)
    },
    PanelContainer: {
      style: getAccordionOverrideStyle("PanelContainer", props)
    },
    ToggleIcon: {
      style: getAccordionOverrideStyle("ToggleIcon", props)
    },
    ToggleIconGroup: {
      style: getAccordionOverrideStyle("ToggleIconGroup", props)
    }
  }, overrides), [overrides, resolvedStyles, props]);
};

export { getAccordionOverrideStyle, useAccordionOverrides };
